export * from './RatingsIcon';
